import { useDispatch } from 'react-redux'
import {
  openRegisterModal as openRegister,
  openLoginModal,
  openModal,
} from 'Modules/modals/actions'
import { handleViewedTracker as viewTracker } from 'Components/ViewedPageTracker/useViewedPageTracker'
import { MODAL_TYPE, SL_GATE } from 'Defaults/modals'
import { checkIsArchive } from 'Utils'

const clickOriginGateList = ({ isArchived, source }) => {
  switch(source) {
    case SL_GATE.LISTING_CARD_IMAGE:
      return isArchived ? SL_GATE.ARCHIVE_LISTING_CARD_IMAGE : source
    case SL_GATE.LISTING_CARD_INFO:
      return isArchived ? SL_GATE.ARCHIVE_LISTING_CARD_INFO : source
    case SL_GATE.SEARCH_MARKER_LISTING_IMAGE:
      return isArchived ? SL_GATE.SEARCH_MARKER_ARCHIVE_LISTING_IMAGE : source
    case SL_GATE.SEARCH_MARKER_LISTING_INFO:
      return isArchived ? SL_GATE.SEARCH_MARKER_ARCHIVE_LISTING_INFO : source
  }
  return source
}
export const getListingComponent = (isArchived) => (
  isArchived ? 'ArchiveListing' : 'Listing'
)
const getLookups = (listing) => {
  if(!listing) return {}
  const isArchived = checkIsArchive(listing.status)
  const component = getListingComponent(isArchived)
  return {
    isArchived,
    lookups: {
      id: listing.id,
      component,
    },
  }
}

const useListingOpenLoginSignup = (
  {
    viewedTrackerHandler = viewTracker,
    sourcePage,
    modalSource = 'ListingPreview',
  },
) => {
  const dispatch = useDispatch()
  // handle after login or signup

  const openLogin = ({
    gate,
    listing,
    termsConditionRequiredId,
  }) => {
    const { lookups, isArchived } = getLookups(listing)
    if(lookups) viewedTrackerHandler({ lookups })
    const listingGate = clickOriginGateList({ isArchived, source: gate })
    dispatch(openLoginModal({
      modalSource: `${modalSource} ${sourcePage} ${listingGate}`,
      modalData: { gate: listingGate },
      nextModalType: termsConditionRequiredId ? MODAL_TYPE.LISTING_TERMS_CONDITION : '',
      nextModalData: {
        listingSource: {
          id: termsConditionRequiredId,
          name: listing?.source,
        },
      },
    }))
  }

  const openSignup = (
    {
      gate,
      listing,
      termsConditionRequiredId,
    },
  ) => {
    const { lookups, isArchived } = getLookups(listing)
    if(lookups) viewedTrackerHandler({ lookups })
    const listingGate = clickOriginGateList({ isArchived, source: gate })
    let payload = {
      modalSource: `${modalSource} ${sourcePage} ${listingGate}`,
      modalData: {
        gate: listingGate,
      },
    }
    if(termsConditionRequiredId && listing?.source) {
      payload = {
        ...payload,
        nextModalType: MODAL_TYPE.LISTING_TERMS_CONDITION,
        nextModalData: {
          executeAfterSuccess: () => dispatch(openModal({
            modalType: MODAL_TYPE.SIGNUP_SUCCESS,
            modalData: {
              gate: listingGate,
            },
          })),
          listingSource: {
            id: termsConditionRequiredId,
            name: listing?.source,
          },
        },
      }
    }
    dispatch(openRegister(payload))
  }
  return {
    openLogin,
    openSignup,
  }
}

useListingOpenLoginSignup.propTypes = {}

export default useListingOpenLoginSignup

